import "../styles/style.css";
import "../styles/reset.css";
import "../styles/fonts.css";
import "../styles/sidebar.css";
import "../styles/validation.css";

import { uiState } from "./state/uiState.js";
import { renderLoginPage } from "./pages/login/loginPage.js";
import { renderDemirbasPage, resetDemirbasPage, resetDemirbasSessionState } from "./pages/demirbas/demirbasPage.js";
import { renderTanimlarPage } from "./pages/tanimlar/tanimlarPage.js";
import { renderUrunAgaciPage, resetUrunAgaciPage } from "./pages/urunAgaci/urunAgaciPage.js";
import { renderKisilerPage, resetKisilerPage } from "./pages/kisiler/kisilerPage.js";
import { renderUyeliklerPage, resetUyeliklerPage } from "./pages/uyelikler/uyeliklerPage.js";
import { initSifreDegistirDialog } from "./pages/profil/sifreDegistirDialog.js";
import { renderLogPage, resetLogPage } from "./pages/log/logPage.js";
import { renderAmortismanPage, resetAmortismanPage } from "./pages/amortisman/amortismanPage.js";
import { masaustuUyarisiGoster } from "./utils/masaustuUyarisi.js";

const PAGE_ROLES = {
	demirbas: ["admin", "kullanici", "goruntuleyici"],
	"tablo-tanimlar": ["admin"],
	"urun-agaci-yonetimi": ["admin"],
	"amortisman-takip": ["admin", "kullanici"],
	kisiler: ["admin"],
	uyelikler: ["admin"],
	log: ["admin"],
};

const PAGE_TITLES = {
	demirbas: "Demirba\u015flar",
	"tablo-tanimlar": "Tan\u0131mlar",
	"urun-agaci-yonetimi": "\u0130li\u015fki Y\u00f6netimi",
	"amortisman-takip": "Amortisman Takibi",
	kisiler: "Ki\u015filer",
	uyelikler: "\u00dcyelikler",
	log: "\u0130\u015flem Kay\u0131tlar\u0131",
};

const PATH_TO_PAGE = {
	"/": "demirbas",
	"/demirbas": "demirbas",
	"/tanimlar": "tablo-tanimlar",
	"/urun-agaci": "urun-agaci-yonetimi",
	"/amortisman-takip": "amortisman-takip",
	"/kisiler": "kisiler",
	"/uyelikler": "uyelikler",
	"/log": "log",
};

const PAGE_TO_PATH = {
	demirbas: "/demirbas",
	"tablo-tanimlar": "/tanimlar",
	"urun-agaci-yonetimi": "/urun-agaci",
	"amortisman-takip": "/amortisman-takip",
	kisiler: "/kisiler",
	uyelikler: "/uyelikler",
	log: "/log",
};

const PAGE_RESETTERS = {
	demirbas: resetDemirbasPage,
	"urun-agaci-yonetimi": resetUrunAgaciPage,
	"amortisman-takip": resetAmortismanPage,
	kisiler: resetKisilerPage,
	uyelikler: resetUyeliklerPage,
	log: resetLogPage,
};

function pageFromCurrentPath() {
	return PATH_TO_PAGE[window.location.pathname] ?? "demirbas";
}

function syncSidebarSelection() {
	document.querySelectorAll(".sidebar-item").forEach((el) => el.classList.remove("selected"));
	const active = document.querySelector(`.sidebar-item[data-page="${uiState.currentPage}"]`);
	if (active) active.classList.add("selected");
}

function updateNavbarTitle() {
	const titleEl = document.querySelector(".navbar-page-title");
	if (titleEl) titleEl.textContent = PAGE_TITLES[uiState.currentPage] ?? "";
}

function renderCurrentPage() {
	switch (uiState.currentPage) {
		case "demirbas":
			renderDemirbasPage();
			break;
		case "tablo-tanimlar":
			renderTanimlarPage();
			break;
		case "urun-agaci-yonetimi":
			renderUrunAgaciPage();
			break;
		case "amortisman-takip":
			renderAmortismanPage();
			break;
		case "kisiler":
			renderKisilerPage();
			break;
		case "uyelikler":
			renderUyeliklerPage();
			break;
		case "log":
			renderLogPage();
			break;
		default:
			break;
	}

	const viewIds = [
		"demirbas-view",
		"tablo-tanimlar-view",
		"urun-agaci-yonetimi-view",
		"amortisman-takip-view",
		"kisiler-view",
		"uyelikler-view",
		"log-view",
	];
	viewIds.forEach((id) => {
		const el = document.getElementById(id);
		if (el) el.style.display = id === `${uiState.currentPage}-view` ? "" : "none";
	});

	updateNavbarTitle();
}

function applyUserToUI(user) {
	const initialsEl = document.querySelector(".profile-initials");
	const nameEl = document.querySelector(".profile-name");
	if (initialsEl) initialsEl.textContent = user.initials;
	if (nameEl) nameEl.textContent = user.adSoyad;

	document.querySelectorAll(".sidebar-item[data-page]").forEach((item) => {
		const allowed = PAGE_ROLES[item.dataset.page] ?? [];
		item.style.display = allowed.includes(user.yetki) ? "" : "none";
	});
}

function showApp() {
	document.querySelector(".main").style.display = "";
	navigateTo(pageFromCurrentPath(), false);
	masaustuUyarisiGoster();
}

function resetFilterPages() {
	Object.values(PAGE_RESETTERS).forEach((resetPage) => resetPage?.());
}

function showLogin() {
	resetFilterPages();
	resetDemirbasSessionState();
	document.querySelector(".main").style.display = "none";
	history.replaceState({}, "", "/");
	renderLoginPage({
		onSuccess: (user) => {
			applyUserToUI(user);
			showApp();
		},
	});
}

const originalFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
	const res = await originalFetch(...args);
	const url = args[0]?.toString() ?? "";
	if (res.status === 401 && !url.includes("/api/login") && !url.includes("/api/me")) {
		uiState.currentUser = null;
		showLogin();
	}
	if (res.status === 403) {
		const data = await res.clone().json().catch(() => ({}));
		if (data.code === "must_change_password") window.openSifreDegistirDialog?.(false);
	}
	return res;
};

async function logout() {
	try {
		await fetch("/api/logout", { method: "POST" });
	} catch {
		// sessiz devam
	}
	uiState.currentUser = null;
	showLogin();
}

async function initAuth() {
	try {
		const res = await fetch("/api/me");
		if (res.ok) {
			const { user } = await res.json();
			uiState.currentUser = user;
			applyUserToUI(user);
			showApp();
		} else {
			showLogin();
		}
	} catch {
		showLogin();
	}
}

function navigateTo(page, pushState = true) {
	const allowed = PAGE_ROLES[page] ?? [];
	const redirected = !allowed.includes(uiState.currentUser?.yetki);
	if (redirected) page = "demirbas";

	const previousPage = uiState.currentPage;
	if (previousPage !== page) PAGE_RESETTERS[previousPage]?.();
	uiState.currentPage = page;

	if (redirected) {
		history.replaceState({ page }, "", PAGE_TO_PATH[page]);
	} else if (pushState) {
		history.pushState({ page }, "", PAGE_TO_PATH[page]);
	}

	syncSidebarSelection();
	renderCurrentPage();
}

function initNavigation() {
	document.querySelectorAll(".sidebar-item[data-page]").forEach((item) => {
		item.addEventListener("click", () => navigateTo(item.dataset.page));
	});

	window.addEventListener("popstate", (event) => {
		const page = event.state?.page ?? pageFromCurrentPath();
		navigateTo(page, false);
	});
}

function initSidebarToggle() {
	const sidebar = document.querySelector(".sidebar");
	const toggleBtn = sidebar?.querySelector(".sidebar-toggle-btn");
	if (!sidebar || !toggleBtn) return;

	toggleBtn.addEventListener("click", () => {
		sidebar.classList.toggle("collapsed");
	});
}

function initProfileDropdown() {
	const dropdown = document.querySelector(".profile-dropdown");
	if (!dropdown) return;

	const btn = dropdown.querySelector(".profile-btn");
	const menu = dropdown.querySelector(".profile-menu");

	btn?.addEventListener("click", (event) => {
		event.stopPropagation();
		menu.hidden = !menu.hidden;
	});

	document.addEventListener("click", (event) => {
		if (!dropdown.contains(event.target)) menu.hidden = true;
	});

	dropdown.querySelector(".profile-change-password-btn")?.addEventListener("click", () => {
		menu.hidden = true;
		window.openSifreDegistirDialog(false);
	});

	dropdown.querySelector(".profile-logout-btn")?.addEventListener("click", () => {
		menu.hidden = true;
		logout();
	});
}

function syncFieldTitle(field) {
	if (!field) return;
	if (field.matches("select")) {
		const selected = field.options?.[field.selectedIndex];
		field.title = selected?.title?.trim?.() || selected?.textContent?.trim() || "";
		return;
	}
	if (field.matches("input, textarea")) {
		field.title = field.value?.trim?.() || "";
	}
}

function initFieldTitleSync() {
	const selector = "select, input[type=\"text\"], input[type=\"email\"], input[type=\"password\"], input[type=\"date\"], textarea";

	document.addEventListener("change", (event) => {
		const field = event.target?.closest?.(selector);
		if (field) syncFieldTitle(field);
	});

	document.addEventListener("input", (event) => {
		const field = event.target?.closest?.(selector);
		if (field) syncFieldTitle(field);
	});

	document.addEventListener("mouseover", (event) => {
		const field = event.target?.closest?.(selector);
		if (field) syncFieldTitle(field);
	});

	document.addEventListener("mouseover", (event) => {
		const valueEl = event.target?.closest?.(".info-card-yeni-deger");
		if (valueEl) valueEl.title = valueEl.textContent?.trim() || "";
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initSidebarToggle();
	initNavigation();
	initProfileDropdown();
	initFieldTitleSync();
	initSifreDegistirDialog();
	initAuth();
});
